var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("加载中，请稍后...")]),_c('span',[_vm._v(_vm._s(_vm.status)+" ")]),_c('span',[_vm._v(_vm._s(_vm.datetime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }